import { ClassifierResultAnswerTag } from "models/ClassifierResultAnswerTag";
import { AnswerPersistenceMode } from "models/AnswerPersistenceMode";
import { QuestionDependency } from "models/Question";

export enum LmType {
    Hierarchy,
    Always,
    Workflow,
    "Safety Event",
    Conversation,
}

export type Module = {
    id: string;
    organizationId: string;
    renderPlacement: number | null;
    organizationStructureMemberIds: string[];
    questions: Question[];
    lmType: LmType;
    name: string;
    order?: number;
    questionsToDelete?: string[];
    tagsToDelete?: string[];
    isActive: boolean;
    mediaTypes?: number[];
    description?: string;
    displayName?: string;
    moduleCategoryId?: string;
    /**
     * Category name (e.g. "Quality"). Scope by name rather than `moduleCategoryId`: ModuleCategories
     * is a per-tenant table, so the ids differ between organizations.
     */
    moduleCategoryName?: string;
    classifierResultAnswerTags?: ClassifierResultAnswerTag[];
};

export type ModulePreview = Pick<Module, "id" | "name" | "description"> & {
    moduleCategory: ModuleCategory;
};

export type SkinnyModule = {
    id: string;
    organizationStructureMemberIds: string[];
    isActive: boolean;
    name: string;
    description: string;
};

export type NewModule = {
    organizationId: string;
    name: string;
    lmType: LmType;
    organizationStructureMemberIds: string[];
    questions: Question[];
};

export type Question = {
    id?: string;
    classifierId?: string;
    questionText: string;
    answerType: AnswerType;
    helperText: string;
    weight: number;
    required: boolean;
    score?: number;
    tags?: Tag[];
    shortQuestionText?: string;
    rubric?: string;
    category?: string;
    numberOfResponses?: number; //only applies to star rating
    questions?: Question[];
    $uiKey?: string;
    variation?: AnswerType;
    answerTypeId?: string;
    isActive: boolean;
    isNew?: boolean; // to determine between added and persisted questions
    parentId?: string | null;
    dependencies?: QuestionDependency;
    maxLength?: number;
    automatedAnswerPersistenceMode?: AnswerPersistenceMode;
    /**
     * Used for default questions added for SE lm type to disable editing
     */
    isDefault?: boolean;
    questionCategoryId?: string;
};
/*
There are the following answer types:
Scaled Response
Tag Response
Scored Tag Response
Star Rating
Scaled Boolean Response
*/
export type AnswerType = {
    answerTypeName: string;
    variation: string; //applies only to Scaled Boolean Response - this will be Radio or Checkbox
    isScored?: boolean;
    id: string;
    variations?: AnswerType[];
    isFillInAnswer?: boolean;
    excludeFromModuleScoreCalculation?: boolean;
};

export type QuestionCategory = {
    id: string;
    name: string;
};

export type ModuleCategory = {
    id: string;
    name: string;
};

export type Tag = {
    order: number;
    id: string;
    value: string;
    scoredValue: number | null;
    overrideModuleScore: boolean;
    isActive: boolean;
    classifierResultAnswerTag: ClassifierResultAnswerTag;
};
